export const BUSINESS = {
  name: "Thortek Appliance Repair LLC",
  shortName: "THORTEK",
  tagline: "Engineering precision for architectural-grade home appliances",
  phone: "(609) 598-2163",
  phoneHref: "tel:+16095982163",
  email: "jeffhernandez702000@yahoo.com",
  location: "Rahway, New Jersey",
  hours: [
    { days: "Mon – Fri", time: "8:00 AM – 4:00 PM" },
    { days: "Sat – Sun", time: "Closed" },
  ],
  areas: [
    "Rahway — Home Base",
    "Westfield",
    "Garwood",
    "Cranford",
    "Union",
    "Short Hills",
    "Summit",
    "Millburn",
    "…and all of Central & North NJ",
  ],
  brands: ["Sub-Zero", "Wolf", "Viking", "Thermador", "Miele", "Gaggenau", "La Cornue", "Bosch", "Dacor", "Jenn-Air"],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxhcHBsaWFuY2UlMjByZXBhaXIlMjB0ZWNobmljaWFuJTIwZml4aW5nJTIwcmVmcmlnZXJhdG9yJTIwd2FzaGVyJTIwb3ZlbiUyMGx1eHVyeSUyMGtpdGNoZW58ZW58MHx8fHwxNzg5ODMwMjI0fDA&ixlib=rb-4.1.0&q=85",
  range: "https://images.unsplash.com/photo-1776313756994-d9e9ab7b2d5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxhcHBsaWFuY2UlMjByZXBhaXIlMjB0ZWNobmljaWFuJTIwZml4aW5nJTIwcmVmcmlnZXJhdG9yJTIwd2FzaGVyJTIwb3ZlbiUyMGx1eHVyeSUyMGtpdGNoZW58ZW58MHx8fHwxNzg5ODMwMjI0fDA&ixlib=rb-4.1.0&q=85",
  laundry: "https://images.unsplash.com/photo-1722859178623-0345408411fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBob21lJTIwYXBwbGlhbmNlcyUyMGtpdGNoZW4lMjBzdGFpbmxlc3MlMjBzdGVlbCUyMG92ZW4lMjB3YXNoZXIlMjBkcnllcnxlbnwwfHx8fDE3ODk4MzAyMjR8MA&ixlib=rb-4.1.0&q=85",
  ovenDetail: "https://images.unsplash.com/photo-1783377996769-8ae94b0bbac9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxhcHBsaWFuY2UlMjByZXBhaXIlMjB0ZWNobmljaWFuJTIwZml4aW5nJTIwcmVmcmlnZXJhdG9yJTIwd2FzaGVyJTIwb3ZlbiUyMGx1eHVyeSUyMGtpdGNoZW58ZW58MHx8fHwxNzg5ODMwMjI0fDA&ixlib=rb-4.1.0&q=85",
  dishwasher: "https://images.pexels.com/photos/213162/pexels-photo-213162.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const APPLIANCES = [
  "Refrigerator / Freezer",
  "Range / Oven / Cooktop",
  "Dishwasher",
  "Washer",
  "Dryer",
  "Wine Cooler",
  "Ice Maker",
  "Ventilation / Hood",
  "Other",
];

export const TIME_SLOTS = [
  "Morning (8:00 – 11:00 AM)",
  "Midday (11:00 AM – 1:00 PM)",
  "Afternoon (1:00 – 4:00 PM)",
];

export const STATUSES = ["pending", "confirmed", "completed", "cancelled"];

export const STATUS_COLORS = {
  pending: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
  confirmed: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  completed: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  cancelled: "bg-red-500/15 text-red-400 border-red-500/30",
};
